import Swiper from 'swiper/dist/js/swiper.js';

window.addEventListener('load', function() {

  const SwiperInfosPratiques = new Swiper('.js-swiper-infos-pratiques', {
    pagination: {
      el: '.swiper-pagination',
      dynamicBullets: true,
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  });

  const SwiperConsultation = new Swiper('.js-swiper-consultation', {
    pagination: {
      el: '.swiper-pagination',
      dynamicBullets: true,
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  });

  const SwiperMain = new Swiper('.js-swiper-main', {
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    autoplay: {
      delay: 6000,
      disableOnInteraction: false
    },
    loop: 'true',
    breakpoints: {
      640: {
        pagination: {
          el: '.swiper-pagination',
          dynamicBullets: true,
        }
      }
    }
  });

  const SwiperGallery = new Swiper('.js-gallery-slider', {
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    loop: 'true'
  });

});
